import {useContext, useState} from 'react'
import {dataToSelectOptions} from '../../../../utils/common'
import {TasksReportPageContext} from '../../context'
import {useGetProjectsDropdownList} from '../../hooks/useGetProjectsDropdownList'
import {MultiSelect} from '../../../../components/MultiSelect/'
import {SideFilter} from '../../../../components/SideFilter'
import useSaveFilter from '../../hooks/useSaveFilter'

const TasksReportHeader = () => {
  const {
    onProjectChange,
    filtersData,
    refetch,
    isLoading: loading,
  } = useContext(TasksReportPageContext)
  const {isLoading, projectsDropdownList} = useGetProjectsDropdownList()
  const options = dataToSelectOptions(projectsDropdownList, 'name', 'id')
  const {isOperationLoading, onSaveFilter} = useSaveFilter(refetch)

  const [isDrawerOpen, setIsDrawerOpen] = useState(false)

  return (
    <div className='d-flex justify-content-between mb-10'>
      <div>
        <MultiSelect
          options={options}
          isLoading={isLoading}
          className='w-250px'
          handleSelected={(values: any) => {
            const extractedValues = values.map((item: {value: string}) => item.value).join(',')
            onProjectChange(extractedValues)
          }}
          placeholder='Select project'
          defaultSelectedAll={true}
          allValuesSelectedText={'Project: All'}
        />
      </div>
      <div>
        <SideFilter
          filterData={filtersData}
          onApply={onSaveFilter}
          isOperationLoading={isOperationLoading || loading}
          onCancel={() => setIsDrawerOpen(false)}
          isDrawerOpen={isDrawerOpen}
          setIsDrawerOpen={setIsDrawerOpen}
          filterType={'project_task_report'}
        />
      </div>
    </div>
  )
}

export default TasksReportHeader
